import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardThumbnail.css";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
import { IImage, Image } from "~/components/elements/Image";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { Link as ILink } from "~/sanity/types";
import { Tag, TagProps } from "~/components/elements/Tag";

export type CardThumbnailProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    card: {
      title?: string;
      shortTitle?: string;
      text?: IPortableText;
      link?: ILink;
      image?: IImage;
      tag?: TagProps;
    };
    theme?: "light" | "dark";
    hasBackgroundColor?: boolean;
  };

export const CardThumbnail = ({
  card,
  className,
  theme = "light",
  hasBackgroundColor = false,
  ...props
}: CardThumbnailProps) => {
  const { title, shortTitle, text, link, image, tag } = card;

  return (
    <div className={styles.card}>
      {image && (
        <div
          className={styles.imageContainer({
            hasBackgroundColor: hasBackgroundColor,
          })}
        >
          {tag && tag.label && (
            <div className={styles.tag}>
              <Tag
                size="sm"
                label={tag.label}
                link={tag.link}
                theme={theme === "light" ? "lightOutline" : "darkOutline"}
              />
            </div>
          )}
          <Image
            image={image}
            width={500}
            loading="eager"
            className={styles.image}
          />
        </div>
      )}
      <div className={styles.content}>
        {(title || shortTitle) && (
          <div className={styles.heading}>
            {link && link.slug ? (
              <ButtonLink
                theme="dark"
                size="md"
                isPrimary={false}
                link={link}
                icons={{ iconPrimary: <ArrowOutward /> }}
              >
                {(title || shortTitle) && (
                  <Heading as="h3" size="h3">
                    {shortTitle || title}
                  </Heading>
                )}
              </ButtonLink>
            ) : (
              <Heading as="h3" size="h3">
                {shortTitle || title}
              </Heading>
            )}
          </div>
        )}
        {text && <PortableText blocks={text} />}
      </div>
    </div>
  );
};
